import { enum_ } from "valibot"

export enum InputActionType {
  Escape = 1,
  Delete,
  Duplicate,
  RotateClockwise,
  RotateCounterClockwise,
  EndTurn,
  StartTurn,
  Primary, // for selectedTool, this would normally be left click or gamepad A
  Secondary, // for selectedTool, this would normally be right click or gamepad B

  ActionLogMenu,
  CenterToPosition,

  SelectPrevUnit,
  SelectNextUnit,

  CameraDefaultPolarAngle,
  CameraTopDownPolarAngle,

  CameraIncreaseFov,
  CameraDecreaseFov,

  CameraIncreaseFar,
  CameraDecreaseFar,

  CameraIncreasePixelation,
  CameraDecreasePixelation,

  CameraIncreaseZoom,
  CameraDecreaseZoom,

  CameraRotateClockwise,
  CameraRotateCounterClockwise,

  RotateNextHome,
  UnitWait,
  CommitMove,
  UnitPickup,
  PlayersList,
  UnitLoad,
  UnitUnload,
  UnitAnnex,
  UnitBombard,
  UnitMerge,

  Menu, // closes all open menus OR if no menus are open, opens contextually appropriate menu
  ToolBagMenu,

  SelectInspectTool,
  SelectFileTool,
  SelectPaintTool,
  SelectEraseTool,
  SelectToolsTool,
  SelectPlayersTool,
  SelectElevationTool,
  SelectAll,
  SelectNone,
  InvertSelection,
}

export const InputActionTypeSchema = enum_(InputActionType, 'Invalid Input Action Type')
